import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const useSubmitTenderProposal = (tenderId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      axiosInstance.post(`tender-proposals/${tenderId}`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["tender-detail", tenderId],
      });
    },
  });
};

export const useSubmitQuotationProposal = (quotationId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      axiosInstance.post(`quotation-proposals/${quotationId}`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["quotation-detail", quotationId],
      });
    },
  });
};

